import { Repository } from 'typeorm';
import { UnitsData } from './units.entity';
import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';

@Injectable()
export class UnitsDataRepository {
  constructor(
    @InjectRepository(UnitsData)
    private repository: Repository<UnitsData>,
  ) {}

}
